import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  openingBalance: number,
 *  closingBalance: number,
 *  expenditures: number,
 *  fiveYearBankingLimitCompliance: number,
 *  incrementalityCompliance: number,
 *  nextScheduledPayment: string,
 *  revenues: number,
 *  totalMunicipalities: number,
 *  transfers: number }} FinancialsOverview
 */

const api = new Api("api/amo/landing");

/**
 * @param {number} year
 * @returns {Promise<AxiosResponse<FinancialsOverview[]>>}
 */
export const getFinancialOverview = (year) => api.get(`financials/${year}`);
